import { Status, CallAPIAction } from 'api/types'
import Actions from 'redux/actions'
import type { GetRecruitmentDurationRangeResponse } from 'api/prosAPI'

type State = {
  min: number
  max: number
} & Status

const initialState = {
  min: 0,
  max: 0,
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_DURATION_RANGE_ASYNC,
    Actions.GET_DURATION_RANGE_SUCCESS,
    Actions.GET_DURATION_RANGE_FAIL,
    GetRecruitmentDurationRangeResponse
  >,
): State => {
  switch (action.type) {
    case Actions.GET_DURATION_RANGE_ASYNC: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.GET_DURATION_RANGE_SUCCESS: {
      const { payload } = action
      return {
        ...state,
        ...action.status,
        min: payload.min_duration,
        max: payload.max_duration,
      }
    }
    case Actions.GET_DURATION_RANGE_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    default:
      return state
  }
}
